import React, { Component } from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes/Provider';

import PermissionsItem from '../../../CommonUI/PermissionsItem/PermissionsItem';

import styles from './ContactPreferencesCards.Styles';

class ContactPreferencesCards extends Component {
  render() {
    const { theme, images, contactPrefData = [] } = this.props;

    return (
      <View style={styles.container}>
        <VFText i18nKey="contact_preferences_card_description" style={styles.title(theme)} />

        {contactPrefData.map((contactPrefDataItem, index) => (
          <View key={index} style={styles.itemContainer(theme)}>
            {contactPrefDataItem.map((contactItem, indexItem) => (
              <PermissionsItem
                {...contactItem}
                key={indexItem}
                images={images}
                iconSize={32}
                titleStyle={styles.titleCardStyle}
                style={styles.permissionsItem(
                  theme,
                  !!contactItem.icon,
                  indexItem === contactPrefDataItem.length - 1,
                )}
              />
            ))}
          </View>
        ))}
      </View>
    );
  }
}

ContactPreferencesCards.defaultProps = {
  theme: LightThemeColors,
};
ContactPreferencesCards.propTypes = {
  theme: PropTypes.object,
  images: PropTypes.object,
  contactPrefData: PropTypes.array,
};

export default withTheme(ContactPreferencesCards);
